const About = () => {
    return (
        <section id="about" className="px-6 md:px-28 py-12">
            <div className="flex">
                <div className="bg-primary h-9 w-2 mr-3" />
                <p className="text-4xl font-bold">About</p>
            </div>

            <div className="flex flex-col items-center mt-10 md:justify-between space-y-8 md:items-center md:flex-row">
                <div className="max-w-lg">
                    <p className="text-xl mb-4">
                        I am a{' '}
                        <span className="text-primary">
                            {' '}
                            Fullstack Web Developer
                        </span>
                    </p>

                    <p className="leading-6 pb-4">
                        Hi! My name is Anselm Iwuanyanwu. I am a Fullstack
                        developer with over 4 years of experience in frontend
                        and backend technologies.
                    </p>
                    <p className="leading-6 pb-4">
                        I am an excellent problem solver and a creative, capable
                        of analyzing complex issues and finding innovative
                        solutions to improve perfomance and functionality.
                    </p>
                    <p className="leading-6 pb-4">
                        I bring a unique perspective to my work by having a
                        strong commitment to continuous learning and staying
                        updated with the latest industry trends.
                    </p>

                    <div className="flex space-x-4 mt-12">
                        <a href="#contact" className="button">
                            Hire Me
                        </a>
                        <a
                            href="https://drive.google.com/file/d/16JNTTgbCp6sqvPiejaBJy3-aDehCgnCR/view?usp=sharing"
                            className="button-open "
                        >
                            Download CV
                        </a>
                    </div>

                    <div className="flex flex-col space-x-0 space-y-2 mt-8 md:flex-row md:space-x-4 md:space-y-0">
                        <div className="bg-gray-900 py-4 w-[100%] border border-gray-900 text-center md:w-[50%] hover:border-primary">
                            <p className="text-lg font-bold mb-2">Phone</p>
                            <p className="text-sm text-gray-400">
                                0813 253 0997
                            </p>
                        </div>
                        <div className="bg-gray-900 py-4 w-[100%] border border-gray-900 text-center md:w-[50%] hover:border-primary">
                            <p className="text-lg font-bold mb-2">Email</p>
                            <p className="text-sm text-gray-400">
                                anselmchizurum@gmail.com
                            </p>
                        </div>
                    </div>
                </div>
                <div className="ml-auto">
                    <img src="portrait-3.jpg" alt="portrait" />
                </div>
            </div>

            <div></div>
        </section>
    )
}

export default About
